import { StyledCheckbox } from '@elements/Common';
import { Flag } from '@elements/Flag';
import { colors } from '@utility/sales-forecast';
import { Circle, GlobeSimple } from '@phosphor-icons/react';
function RegionColor(props) {
  const { color } = props;
  return <Circle size={12} color={color} weight="fill" />;
}

/**
 * SeasonalityChartRegionSelect component for selecting regions to exclude or include.
 * @param {string[]} props.excludedRegions - Array of excluded regions.
 * @param {Object[]} props.marketplaceDropdown - Array of marketplace dropdown options.
 * @param {Function} props.setExcludedRegions - Function to set the excluded regions.
 * @returns {JSX.Element} - React component for selecting regions.
 */
function SeasonalityChartRegionSelect(props) {
  const { excludedRegions, marketplaceDropdown, setExcludedRegions } = props;

  /**
   * Toggles the exclusion or inclusion of a region in the excludedRegions list.
   * @param {string} value - The value of the region.
   */
  const toggleRegion = value => {
    const updated = excludedRegions.includes(value)
      ? excludedRegions.filter(d => d !== value)
      : [...excludedRegions, value];

    setExcludedRegions(updated);
  };

  return (
    <div className="sk:absolute sk:top-3.5 sk:left-[25px] sk:z-[1] sk:flex sk:items-center sk:gap-[15px] sk:text-fg-tertiary">
      <div className="sk:flex sk:items-center">
        {/* Checkbox for global region */}
        <StyledCheckbox
          className="sk:mr-1"
          checked={!excludedRegions.includes('global')}
          onChange={() => toggleRegion('global')}
          id="region-global"
        />
        <label
          className="sk:flex sk:cursor-pointer sk:items-center"
          htmlFor="region-global"
        >
          <GlobeSimple
            width={20}
            height={15}
            className="sk:mr-[7px] sk:rounded-[3px] sk:bg-primary sk:p-px sk:text-surface"
          />
          <RegionColor color={colors.lineGlobal} />
        </label>
      </div>

      {/* Various marketplace regions */}
      {marketplaceDropdown.map((r, i) => {
        const isChecked = !excludedRegions.includes(r?.name);
        const id = `region-${r?.name}`;

        return (
          <div className="sk:flex sk:items-center" key={id}>
            <StyledCheckbox
              checked={isChecked}
              className="sk:mr-2"
              id={id}
              onChange={() => toggleRegion(r.name)}
            />
            <label
              className="sk:flex sk:cursor-pointer sk:items-center"
              htmlFor={id}
            >
              <Flag name={r?.name} className="sk:mr-1!" />
              <RegionColor color={colors.lineColors[i]} />
            </label>
          </div>
        );
      })}
    </div>
  );
}

export default SeasonalityChartRegionSelect;
